import React from "react";
import KyazsLogo from '../assets/images/kyazs-logo.png';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div className="footer-top">
        <div className="footer-logo">
          <a href="https://caspersantos.dev/">
            <img src={KyazsLogo} alt="Kyazs Dev" width={50} />
          </a>
        </div>
        <div className="footer-social">
          {/* <a href="https://github.com/kyazs" target="_blank" rel="noreferrer"><GitHubIcon/></a> */}
          {/* <a href="https://www.linkedin.com/in/jcasper-santos/" target="_blank" rel="noreferrer"><LinkedInIcon/></a> */}
        </div>
      </div>
      <div className="footer-bottom">
        <p>Website designed & built by <a className="link-name" href="https://caspersantos.dev/" target="_blank" rel="noreferrer">John Casper Santos</a></p>
      </div>
    </footer>
  );
}

export default Footer;